export const PROFILE_BACK_TARGET_KEY = 'profile_back_target';

export const saveProfileBackTarget = (path) => {
  if (!path || path.startsWith('/profile')) return;
  try {
    sessionStorage.setItem(PROFILE_BACK_TARGET_KEY, path);
  } catch (_) {
    // ignore storage errors
  }
};

export const getSavedProfileBackTarget = () => {
  try {
    return sessionStorage.getItem(PROFILE_BACK_TARGET_KEY);
  } catch (_) {
    return null;
  }
};
